const styles = ({spacing, breakpoints}) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: spacing.unit,
  },
  selectControl: {
    color: "#153862",
    fontSize: '16px',
    fontWeight: 500,
    [`@media (max-width:${breakpoints.values.sm}px)`]: {
      fontSize: "14px",
    },
    '&:hover': {
      textDecoration : "underline"
    },
  },
  menuSelect: {
    paddingRight: 0,
    backgroundColor: 'transparent !important'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/StartContainer/LanguageSelect/languageSelect.style.js